import { Button, Grid, Paper, Typography } from '@mui/material';
import React, { useState } from 'react';
import { PageContentExterneDto } from '../../../../services/dtos/page-content-externe.dto';
import { Form, Formik } from 'formik';
import { mixed, object } from 'yup';
import InputForm from '../../../commun/input-form';
import './image-block.form.scss';

/**
 * Renders a form for uploading and displaying an image.
 * @param {Object} props - The props object
 * @param {PageContentExterneDto} props.fieldContent - The external content for the field
 * @param {Function} props.handleSubmit - The submit handler function
 * @param {boolean} props.validate - Indicates whether the form should be validated
 */
export default function ImageBlockForm(props: {
    fieldContent: PageContentExterneDto;
    handleSubmit: any;
    validate: boolean;
}) {
    // Données du fichier uploadé en base64
    const [fileData, setFileData] = useState('');
    // Type du fichier uploadé
    const [fileType, setFileType] = useState('');
    // Nom du fichier uploadé, pour vérification des doubles extensions.
    const [fileName, setFileName] = useState('');
    // Est-ce que le fichier uploadé est valide ?
    const [fileValid, setFileValid] = useState(false);

    // Set les différentes données du fichier après upload
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const content = event.currentTarget.files && event.currentTarget.files[0];
        if (content) {
            setFileType(content.type);
            setFileName(content.name);
            const reader = new FileReader();
            reader.onloadend = () => setFileData(reader.result as string);
            reader.readAsDataURL(content);
        } else {
            setFileType('');
            setFileData('');
            setFileName('');
        }
    };

    // Envoi des données du fichier
    const handleSubmit = () => {
        props.handleSubmit({ contenu: fileData });
    };

    // Vérifie que le fichier est bien une image valide
    const validationSchema = object({
        content: mixed().test('is-file-of-correct-type', "Le fichier n'est pas au bon format", () => {
            let valid = true;
            if (fileType && fileName) {
                // Checking fileType and fileName to validate only when a file is selected
                const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
                const isMultipleExtension = /\.\w+\.\w+$/.test(fileName);
                if (!validTypes.includes(fileType) || isMultipleExtension) {
                    valid = false;
                }
            }
            setFileValid(valid);
            return valid;
        }),
    });

    const iniValues = {
        content: '',
    };

    // Set l'image récupérée dans l'API pour l'afficher
    const originalImage = props.fieldContent ? props.fieldContent.valeur : null;

    return (
        <Grid container>
            <Grid item xs={12}>
                <Paper sx={{ padding: '20px' }}>
                    <Formik initialValues={iniValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
                        <Form>
                            <Grid container>
                                <Grid item xs={12}>
                                    <InputForm
                                        id={'content'}
                                        label={'Insérer une image (.jpeg, .png ou .jpg)'}
                                        name="content"
                                        type={'file'}
                                        handleChange={handleFileChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Typography variant={'button'}>
                                        <Button type="submit" variant="contained" disabled={props.validate}>
                                            Valider
                                        </Button>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Form>
                    </Formik>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                {/* Render de l'image originale ou de celle uploadée */}
                {fileData && fileValid ? (
                    <img className="img" src={fileData} alt="Selected" />
                ) : (
                    originalImage && <img className="img" src={originalImage} alt="Original" />
                )}
            </Grid>
        </Grid>
    );
}
